module.exports = __webpack_public_path__ + "static/media/paymentPaypal.ab57c664.png";